<div id="main-menu" class="menu-wrapper lg:block" tabindex="-1"
  [ngClass]="{ 'hidden': !(isOffcanvasShown$ | async), 'z-20 relative menu-shown': (isOffcanvasShown$ | async) }">
  <div class="mobile-menu py-3 flex justify-center align-center" [ngClass]="{ 'hidden': !(isOffcanvasShown$ | async) }">
    <div class="flex-1 text-center">
      <a routerLink="/" class="logo-link flex items-center justify-center py-3">
        <span>Tidy Ranking</span>
      </a>
    </div>
    <div class="flex-none px-2">
      <p-button icon="bi bi-x" size="large" [rounded]="true" [text]="true" (click)="closeOffcanvas()" />
    </div>
  </div>

  <div class="menu-main flex flex-col p-0">
    <ul>
      <li class="menu-account bg-slate-900" *ngIf="(currentUser$ | async) as user">
        <div class="py-3 flex items-center cursor-pointer" (click)="toggleAccount()">
          <div class="flex-1 font-bold text-xl px-4">
            {{ user?.getUsername() }}
          </div>
          <div class="flex-none px-3">
            <i class="bi" [ngClass]="{ 'bi-chevron-up': showAccount, 'bi-chevron-down': !showAccount }"></i>
          </div>
        </div>
        <ul class="container" [ngClass]="{ 'collapsed': !showAccount }">
          <!-- <li><a routerLink="/account" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-person-circle"></i> Account</a></li>
          <li><a routerLink="/account/settings" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-sliders"></i> Settings</a></li> -->
          <li><a href="#" (click)="logout($event)" class="hover:bg-slate-800!"><i class="bi bi-box-arrow-left"></i> Logout</a></li>
        </ul>
      </li>

      <!-- <li><a routerLink="/" routerLinkActive="active" (click)="closeOffcanvas()" [routerLinkActiveOptions]="{exact: true}"><i class="bi bi-layers-half"></i> Dashboard</a></li> -->
      <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeOffcanvas()"><i
            class="bi bi-buildings"></i> Organizations</a></li>

      <li class="menu-org" *ngIf="currentOrg$ | async as org">
        <div class="py-3 flex items-center">
          <div class="flex-1 font-bold text-xl px-4">
            {{ org.name }}
          </div>
        </div>

        <ul class="container">
          <!-- <li><a routerLink="/overview" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-buildings-fill"></i> Overview</a></li> -->
          <li><a routerLink="/members" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-person-bounding-box"></i> Members</a></li>
          <li><a routerLink="/matches" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-diagram-2-fill"></i> Matches</a></li>
          <li><a routerLink="/seasons" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-calendar3"></i> Seasons</a></li>
          <li><a routerLink="/snapshots" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-camera"></i> Snapshots</a></li>
          <li><a routerLink="/import" routerLinkActive="active" (click)="closeOffcanvas()"><i class="bi bi-box-arrow-in-down-right"></i> Import</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>

  <!-- <div class="d-flex menu-footer justify-content-center">
    <a href="/contact">Contact</a>
    <a href="/help">Help</a>
  </div> -->
</div>

<div class="bg-black opacity-70 fixed h-screen w-screen z-10 top-0 bottom-0 left-0 right-0 lg:hidden"
  [ngClass]="{ 'hidden': !(isOffcanvasShown$ | async) }" (click)="closeOffcanvas()"></div>